import SimpleBar from "simplebar";

Array.prototype.forEach.call(
    document.querySelectorAll(`[data-mysimplebar]`),
    (el) => {
        let size = 96;

        if (el.dataset.size) {
            size = parseInt(el.dataset.size, 10);
        }

        new SimpleBar(el, {
            autoHide: false,
            scrollbarMinSize: size,
            scrollbarMaxSize: size,
        });
    }
);
